import { createAction } from '@reduxjs/toolkit';
import { GetLoFInspectionFieldsApiProps } from '@Services/LoF/LoF.services';
import { Category, Component } from '@Types';

export const getLoFConfigResolved = createAction<Category[]>(
	'LoF/getLoFConfigResolved',
);
export const getLoFConfigRejected = createAction('LoF/getLoFConfigRejected');

export const addLoFConfig = createAction<Category>('LoF/addLoFConfig');

export const setLoFConfig = createAction<Category[]>('LoF/setLoFConfig');

export const getLoFInspectionFields =
	createAction<GetLoFInspectionFieldsApiProps>('LoF/getLoFInspectionFields');
export const getLoFInspectionFieldsResolved = createAction<Category[]>(
	'LoF/getLoFInspectionFieldsResolved',
);
export const getLoFInspectionFieldsRejected = createAction(
	'LoF/getLoFInspectionFieldsRejected',
);
export const getLoFFields = createAction<string>('LoF/getLoFFields');
export const getLoFFieldsResolved = createAction<Category[]>(
	'LoF/getLoFFieldsResolved',
);
export const getLoFFieldsRejected = createAction('LoF/getLoFFieldsRejected');

export const addLoFComponent = createAction<{
	categoryName: string;
	component: Component;
}>('LoF/addLoFComponent');

export const setLoFComponent = createAction<{
	categoryName: string;
	componentName: string;
	component: Component;
}>('LoF/setLoFComponent');

export const setLoFComponents = createAction<{
	categoryName: string;
	components: Component[];
}>('LoF/setLoFComponents');

export const saveLoF = createAction<{
	refresh: () => void;
}>('LoF/saveLoF');
export const saveLoFResolved = createAction('LoF/saveLoFResolved');
export const saveLoFRejected = createAction('LoF/saveLoFRejected');

export const deleteCategory = createAction<{
	forLoF: boolean;
	categoryName: string;
}>('LoF/deleteCategory');

export const setLofIsChanged = createAction<boolean>('Lof/setLofIsChanged');
